import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Frame from '@/components/base/Frame';
import Hero from './components/Hero';
import Services from './components/Services';
import Outcomes from './components/Outcomes';
import SelectedWork from './components/SelectedWork';
import WorkingTogether from './components/WorkingTogether';
import FinalCta from './components/FinalCta';

/*
 * LOCKED — DO NOT MODIFY. Verified in preview + production.
 * Visibility contract: the page is ALWAYS visible. Nothing here may hide it.
 * The section target comes only from this navigation (state or hash) and is
 * re-evaluated only when the navigation itself changes (location.key).
 */
export default function Home() {
  const location = useLocation();
  const target = location.pathname.replace(/^\/+|\/+$/g, '')
    || new URLSearchParams(location.search).get('section')
    || (location.hash ? decodeURIComponent(location.hash.slice(1)) : '');

  useLayoutEffect(() => {
    if (!target) { window.scrollTo(0, 0); return; }
    document.getElementById(target)?.scrollIntoView({ block: 'start', behavior: 'auto' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key, location.pathname, location.hash, location.search]);

  // Re-align briefly while images/figures settle. Purely positional — never affects visibility.
  useEffect(() => {
    if (!target) return undefined;
    const align = () => document.getElementById(target)?.scrollIntoView({ block: 'start', behavior: 'auto' });
    const timers = [80, 200, 450].map((ms) => window.setTimeout(align, ms));
    return () => timers.forEach((t) => window.clearTimeout(t));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key, location.pathname, location.hash, location.search]);

  return (
    <div className="relative min-h-screen bg-background-50">
      <Header />
      <main>
        <Frame>
          <Hero />
          <Services />
          <Outcomes />
          <SelectedWork />
          <WorkingTogether />
          <FinalCta />
        </Frame>
      </main>
    </div>
  );
}